import { useEffect, useState } from 'react'
import { Input } from 'antd'
import { getRepeatCount } from '../helpers'
import withRepeater from './withRepeater'

SequencedFormStringInput = ({
  form,
  formItem,
  config = {},
  loading,
  queries,
  label,
  props... }) ->

  <Input
    { props... }
    allowClear
    disabled={config?.disabled}
    placeholder={_.startCase(formItem)}
  />

export default withRepeater(SequencedFormStringInput)
